// react-big-calendar renders a LEFT time gutter column in WEEK view.
// We must account for that by rendering an empty leading column.
const TIME_GUTTER_WIDTH = 78; // matches RBC default (~70–80px)
export const weeklyRoleFooterContainer = {
  display: 'grid',
  gridTemplateColumns: `${TIME_GUTTER_WIDTH}px repeat(7, 1fr)`,
  borderTop: '1px solid',
  borderColor: 'var(--border-color)',
  backgroundColor: 'var(--background)',
};

// Cell for each day footer column
export const weeklyRoleFooterDayCell = {
  p: 1,
  display: 'flex',
  flexDirection: 'column',
  borderRight: '1px solid',
  overflowX: 'auto',
  borderColor: 'var(--border-color)',
};

// Shared row layout for role + total rows
export const weeklyRoleFooterRow = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  mb: 1,
};

// Separator above total row
export const weeklyRoleFooterTotalSeparator = {
  mt: 0.5,
  pt: 1,
  borderTop: '1px solid',
  borderColor: 'var(--border-color)',
};
